import { Dialog, DialogContent, Box, Typography, IconButton } from '@mui/material';
import { FiAlertTriangle } from 'react-icons/fi';
import { RxCross2 } from 'react-icons/rx';
import Button from './Button';

interface PaymentDueModalProps {
  open: boolean;
  onClose: () => void;
  onPayNow?: () => void;
  paying?: boolean;
}

const PaymentDueModal = ({ open, onClose, onPayNow, paying }: PaymentDueModalProps) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth PaperProps={{ sx: { borderRadius: '12px' } }}>
      <DialogContent sx={{ p: { xs: 3, sm: 4 }, position: 'relative' }}>
        <IconButton
          onClick={onClose}
          aria-label='Close'
          sx={{ position: 'absolute', top: 12, right: 12, color: '#1F2937' }}
        >
          <RxCross2 size={20} />
        </IconButton>

        <Box display='flex' justifyContent='center' mt={1}>
          <Box
            sx={{
              height: 80,
              width: 80,
              borderRadius: '50%',
              backgroundColor: '#FFFBEB',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <FiAlertTriangle size={36} color='#D97706' />
          </Box>
        </Box>

        <Typography textAlign='center' fontSize={22} fontWeight={600} color='#0F172A' mt={2}>
          Past Due
        </Typography>

        <Typography
          textAlign='center'
          fontSize={14}
          color='#6B7280'
          lineHeight={1.7}
          mt={1.5}
          mx='auto'
          sx={{ maxWidth: 480 }}
        >
          We wanted to remind you that your previous invoice is currently overdue. To ensure uninterrupted access to all
          services, please complete your payment at your earliest convenience.
        </Typography>

        <Box sx={{ mt: 3, p: 2.5, borderRadius: '8px', backgroundColor: '#FFFBEB' }}>
          <Typography fontSize={14} fontWeight={500} color='#D97706' mb={0.5}>
            Billing Note:
          </Typography>
          <Box component='ul' sx={{ pl: 2.5, m: 0 }}>
            <Typography component='li' fontSize={14} color='#D97706' lineHeight={1.8}>
              Existing usage and pending charges will still apply based on the current plan.
            </Typography>
            <Typography component='li' fontSize={14} color='#D97706' lineHeight={1.8}>
              If dues are not cleared till next billing, your business will automatically move to Inactive state.
            </Typography>
          </Box>
        </Box>

        <Box display='flex' justifyContent='flex-end' gap={1.5} mt={3}>
          <Button
            variant='outlined'
            onClick={onClose}
            sx={{
              borderRadius: '28px',
              textTransform: 'none',
              px: 3.5,
              py: 1,
              fontSize: 14,
              minWidth: 110,
              borderColor: '#9CA3AF',
              color: '#4B5563',
              '&:hover': {
                borderColor: '#6B7280',
                backgroundColor: 'transparent',
                color: '#374151'
              }
            }}
          >
            Cancel
          </Button>

          <Button
            isPending={paying}
            onClick={onPayNow}
            variant='contained'
            sx={{
              borderRadius: '28px',
              textTransform: 'none',
              px: 3.5,
              py: 1,
              fontSize: 14,
              minWidth: 110,
              backgroundColor: '#D97706',
              color: '#fff',
              boxShadow: 'none',
              '&:hover': { backgroundColor: '#D97706', boxShadow: 'none' }
            }}
          >
            Pay Now
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentDueModal;
